import { wizardEnTranslations } from '@momentum/types';
import { wizardHeTranslations } from './wizard.he.js';
export const wizardTranslations = {
    en: wizardEnTranslations,
    he: wizardHeTranslations,
};
